module.exports = __webpack_public_path__ + "static/img/thought_report.71c35600.png";